import React from "react";
import { Box,Button, Fab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { accountsmanagement, HRService } from "../../../config";
import { imprestLinesColumns, purchaseInvoiceLinesColumns} from "../../../data/DynamicTable/Collumns"; 
import { allFeeNotesLinesQuery, allImprestLinesQuery } from "../../../data/Axios/queries"; 
import { useNavigate, useLocation } from "react-router-dom";
import ImprestApplicationLineForm from "./imprestLineForm";

const base_url = HRService.uri;

function ImprestApplicationLines() {
     const location = useLocation();
     // Retrieve data using the key for Fee Notes
     const data = 
        location.state?.imprestData ||
        JSON.parse(localStorage.getItem("ImprestData"));
        
     const theme = useTheme();
     const colors = tokens(theme.palette.mode);
     const navigate = useNavigate();

     const handleGoBack = () => {
        const backPath = location.state?.from || '/imprest-applications';
       navigate(backPath);
       }
       

     // Check if parent data is available before proceeding
     if (!data || !data.id) {
        return (
            <Box m="2px" p="1rem">
                <p>Error: Parent purchase invoice data not found in local storage.</p>
            </Box>
        );
     }
     
     const ImprestId = data.id;
     // Define actions for Fee Note Lines
     const actions = {
        require : "id",
         entity: "Imprest Line",
         edit: {
             key: "EDIT",
             button_name: "Edit Line",
             Show_Button: true, 
             permission: "hasNoPermission", 
            roleGroupId: [1, 2, 3, 4], 
         },
         add: {
             key: "ADD",
             button_name: "Add",
             Show_Button: true, 
             permission: "hasNoPermission", 
            roleGroupId: [1, 2, 3, 4], 
         },
         showStatus: false,
         
         // *** UPDATE: Set modelName to match the GraphQL operation name (without 'query') ***
         modelName: "imprestApplicationLinesByImprestId", 
         dataObject: {
             // *** UPDATE: The input field must match the GraphQL variable (feeNotesLines) ***
             inputFields: {
              
                imprestId: ImprestId,
                
            
            },
             
             // *** UPDATE: inputObjectName matches the GraphQL operation name (without 'query') ***
             inputObjectName: "imprestApplicationLinesByImprestId", 
             
             // *** UPDATE: inputSubObjectName is the array of results returned by the operation ***
             // Assuming the results array is directly returned by the operation.
             // If the API nests the array under another field, change this accordingly.
             inputSubObjectName: "imprestApplicationLines", // Often the same as inputObjectName if the array is directly returned.
             
             returnFields: [
                 "id",
                 "imprestId",
                 "expenseTypeId",
                 "description",
                 "accountId",
                 "amountRequested",
                 "accountId",
                 "costCenterId",
                 "projectId",
                 "isActive",
                 "createdBy",
                 "createdDate",
                 "updatedBy",
                 "updatedDate",
             ],
         },
     };


     const title = `Imprest Lines for Document ${data.documentNumber || data.id}`;
     const subtitle = `View All Lines for this Imprest`;

     return (
         <Box m="2px" p="1rem">
           {/* Floating Back Button */}
             <Fab
                color="secondary"
                type="button"
                aria-label="go back"
                onClick={handleGoBack}
                sx={{
                    position: "fixed",
                    top: 120,      
                    left: 270,     
                    zIndex: 1500,
                    width: 40,
                    height: 40,
                    boxShadow: 3,
                    "&:hover": {
                    boxShadow: 6,
                    },
                }}
            >
                <ArrowBackIcon />
            </Fab>

            <DynamicTable
                 title={title}
                 subtitle={subtitle}
                 // *** NOTE: Replace 'allRelievers' with your actual columns array (e.g., feeNoteLinesColumns) ***
                 columns={imprestLinesColumns} 
                 // *** NOTE: Replace 'allUsersQuery' with the actual query that fetches fee note lines (e.g., allFeeNotesLinesQuery) ***
                 //query={allImprestLinesQuery}
                 FormComponent={ImprestApplicationLineForm}
                 base_url={base_url}
                 actions={actions}
             />
         </Box>
     );
}

export default ImprestApplicationLines;